import api from './api';

export const contentService = {
  // Gallery
  getGallery: (category) => api.get('/content/gallery', { params: category && category !== 'all' ? { category } : {} }),
  addGalleryImage: (data) => api.post('/content/gallery', data),
  updateGalleryImage: (id, data) => api.put(`/content/gallery/${id}`, data),
  deleteGalleryImage: (id) => api.delete(`/content/gallery/${id}`),

  // Site Content
  getSiteContent: () => api.get('/content/site'),
  upsertSiteContent: (key, content) => api.put(`/content/site/${key}`, { content }),
};
